import { isDefined } from "@clipboard-health/util-ts";
import { type ShiftStateData } from "@src/appV2/Shifts/Shift/ShiftState/types";
import { isAfter, isSameMinute, parseISO, subMinutes } from "date-fns";

export interface ClockInTimingInfo {
  earliestClockInTime: Date | undefined;
  isAfterEarliestClockInTime: boolean;
  canClockInNow: boolean;
}

export function getClockInTimingInfo({
  shiftStart,
  shiftState,
  currentDate = new Date(),
}: {
  shiftStart: string;
  shiftState: ShiftStateData;
  currentDate?: Date;
}): ClockInTimingInfo {
  const shiftStartDate = parseISO(shiftStart);

  const earliestClockInTime =
    shiftState.metadata.isEarlyClockInEnabled && isDefined(shiftStartDate)
      ? subMinutes(shiftStartDate, shiftState.metadata.earlyClockInEnabledInMinutes ?? 0)
      : shiftStartDate;

  const isAfterEarliestClockInTime = isDefined(earliestClockInTime)
    ? isAfter(currentDate, earliestClockInTime) || isSameMinute(currentDate, earliestClockInTime)
    : false;

  return {
    earliestClockInTime,
    isAfterEarliestClockInTime,
    canClockInNow: isAfterEarliestClockInTime,
  };
}
